var render = function render(){var _vm=this,_c=_vm._self._c;return _c('rent-status-base',{attrs:{"title":_vm.title,"rent-statuses":_vm.rentStatuses}})
}
var staticRenderFns = []

export { render, staticRenderFns }